const dropdown = document.querySelector('.js-lang-dropdown');

document.querySelectorAll('.js-lang-btn').forEach(btn => {
    btn.addEventListener('click', e => {
        e.preventDefault();

        if (App.langIsOpen) {
            closeLanguage(dropdown);
        } else {
            openLanguage(dropdown);
        }
    });
});

document.querySelectorAll('.js-lang-close').forEach(btn => {
    btn.addEventListener('click', e => {
        e.preventDefault();
        closeLanguage(dropdown);
    });
});

/**
 * Открываем
 */
function openLanguage(dropdown) {
    dropdown.classList.add('_is-visible');
    App.langIsOpen = true;

    if (window.innerWidth < 768) {
        App.lockScroll.lock();
    }
}

/**
 * Закрываем
 */
function closeLanguage(dropdown) {
    dropdown.classList.remove('_is-visible');
    App.langIsOpen = false;

    if (window.innerWidth < 768) {
        App.lockScroll.unlock();
    }
}


// WEBPACK FOOTER //
// ./_src/js/Language.js